import React from 'react';
import Select from 'react-select';
import Breadcrumbs from 'react-breadcrumbs';
import Toaster from 'toastr';
import {connect} from 'react-redux';
import {Permissioned} from 'react-permissions';
import Divider from '../../common/divider';
import PageTitle from '../../common/pageTitle';
import Util from '../../../util/util';
import Messages from '../../../configurations/messages';
import Permissions from '../../../configurations/permissions';
import Constants from '../../../configurations/constants';
import SettlementsApi from '../../../api/SettlementsApi';
import SettlementRequestsTable from './settlementRequestsTable';
import SettlementRequestCancelModal from './settlementRequestCancelModal';




class SettlementRequestPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            settlementRequests: [],
            statuses : [],
            status : null,
            totalCount: 0,
            loading: false,
            performingAction : false,
            filterParams : {},
            pages: 0,
            openModalFlag: false,
            createFlag: false,
            pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
            pageNum: 0, //Zero based index
        };
        this.onTableChange = this.onTableChange.bind(this);
        this.onRowButtonClick = this.onRowButtonClick.bind(this);
        this.onNewButtonClick = this.onNewButtonClick.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    componentDidMount() {
        //Get Status
        SettlementsApi.getSettlementRequestStatuses()
            .then(response => {
                let statuses  = response.data.map(status => ({ label : status , value: status}) ); 
                this.setState({ statuses });
            })
            .catch(error => {
                Toaster.error(`${error.status} - ${Messages.ERROR_DISPUTE_CATEGORIES} -  ${error.data ? error.data.description : error.statusText}`);
                console.log(error);
            })

        //Load data on mount
        this.reloadSettlements();
    }

    onNewButtonClick(evt) {
        this.setState({ openModalFlag: true, createFlag: true });
    }
    handleFilterChange(evt) {
        this.setState({ status: evt }, () => this.reloadSettlements());    
    }

    render() {
        return (

            <div>
                <div id="page-breadcrumb" className="breadcrumb-container">
                    <Breadcrumbs routes={this.props.routes}
                        params={this.props.params} />
                </div>
                <PageTitle title="Settlement Processing Requests" />
                <Divider />
                <div className="mini-filter">
                    <div className="filter-select">
                        <Select
                            placeholder="Status"
                            onChange={this.handleFilterChange}
                            options={this.state.statuses}
                            value={this.state.status}
                        />
                    </div>
                    
                </div>
                <SettlementRequestsTable
                    loading={this.state.loading}
                    onTableChange={this.onTableChange}
                    page={this.state.pageNum}
                    pages={this.state.pages}
                    disableActions={this.state.performingAction}
                    defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
                    settlementRequests={this.state.settlementRequests}
                />

                {this.state.openModalFlag &&
                    <SettlementRequestCancelModal
                        isNew={this.state.createFlag}
                        isOpen={this.state.openModalFlag}
                        onRequestClose={this.handleCloseModal}
                        requestReference={this.state.selectedSettlementRequest.requestReference}
                    />
                }
            </div>
        )
    }

    handleCloseModal(event, reloadDataFlag) {
        this.setState({ selectedSettlementRequest: null, openModalFlag: false });
        if (reloadDataFlag) {
            this.reloadSettlements();
        }
    }


    onTableChange(state, instance) {
        let pageSize = instance.state.pageSize;
        let pageNum = (instance.state.page); //table page  - Zero based index
        this.setState({ pageSize: pageSize, pageNum: pageNum });
        if (this.state.filterParams) {
            let params = Util.clone(this.state.filterParams);
            params.pageSize = pageSize;
            params.pageNum = pageNum + 1;

            this.loadSettlements(params);
        }

    }

    loadSettlements(params, resetPageNumber) {
        //Reset states 
        let stateUpdate = { loading: true, settlementRequests: [] };
        if (resetPageNumber) {
            stateUpdate.pageNum = 0;
            params.pageNum = 1;
        }
        this.setState(stateUpdate);
        params.pageSize = params.pageSize || this.state.pageSize;
        params.pageNum = params.pageNum || (this.state.pageNum + 1);

        let status = this.state.status;

        if (status && status.value) {
            params.status = status.value;
        }
        SettlementsApi.getSettlementRequests(params)
            .then((response) => {
                let data = response.data.content;
                let totalCount = response.data.count;
                let pages = totalCount ? Math.ceil(totalCount / (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)) : 0;
                if (data.length === 0)
                    Toaster.warning("No records found.", "Settlement Processing Request")
                else{
                    //add click handler to each data object
                    data = data.map(val => {val.clickHandler = this.onRowButtonClick; return val}  )
                }
                this.setState({ settlementRequests: data, loading: false, filterParams: params, totalCount: totalCount, pages: pages });
            })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${Messages.ERROR_SETTLEMENT_REQUESTS} - ${error.data ? error.data.description : error.statusText}`, `${error.status}`);
                this.setState({ loading: false });
            });
    }

    onRowButtonClick(index, action) {
        let selectedSettlementRequest =  this.state.settlementRequests[index];
        if( action !== Constants.SETTLEMENT_REQUEST_ACTION_CANCEL){
                this.processRequest(selectedSettlementRequest.requestReference, {action});         
        }
        else{
             this.setState({ selectedSettlementRequest, openModalFlag: true, createFlag: false });
        }
       
    }

    reloadSettlements() {
        this.setState({settlementRequests : []});
        this.loadSettlements({ pageSize: this.state.pageSize });
    }

    processRequest(reference, data){
        this.setState({ performingAction: true }); 
        SettlementsApi.processSettlementRequest(reference, data)
            .then(response => {
                let message = "";

                if(data.action === Constants.SETTLEMENT_REQUEST_ACTION_PROCESS)
                    message = Messages.SUCCESS_SETTLEMENT_REQUEST_PROCESSED;
                if(data.action === Constants.SETTLEMENT_REQUEST_ACTION_MAP) 
                    message =  Messages.SUCCESS_SETTLEMENT_REQUEST_MAPPED; 
                if(data.action === Constants.SETTLEMENT_REQUEST_ACTION_CANCEL)
                    message = Messages.SUCCESS_SETTLEMENT_REQUEST_CANCELED;
                
                Toaster.success(`${message}`, `${reference}`);
                this.reloadSettlements();
                this.setState({ performingAction: false }); 
                
            })
            .catch(error => {
                console.log(error);
                Toaster.error(`${error.data ? error.data.description : error.statusText}`, `${error.status} - ${reference}`);
                this.setState({ performingAction: false });       
            })
    }

}


export default connect(Util.defaultMapStateToProps)(Permissioned(SettlementRequestPage, [Permissions.VIEW_SETTLEMENT_REQUEST]));


// WEBPACK FOOTER //
// ./src/components/admin/settlementRequests/settlementRequestsPage.js